import React from "react";

export default function SelectBase(props) {
  return <input {...props} readOnly placeholder="" />;
}
